import React from 'react';
import type { Claim } from '../../api/claims/interface';
import type { ClaimFile } from '../../api/files/interface';

export const ClaimDetailsContext = React.createContext<{
  claimMetadata?: Claim;
  files?: Record<string, ClaimFile>;
}>({});
